export default class ImportChunkError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "ImportChunkError";
  }
}
